var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalander(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    className: "w-50",
    fill: "#fff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-white",
    d: "M177.3,186.2H20.7c-4,0-7.3-3.3-7.3-7.3V33.8c0-4,3.3-7.3,7.3-7.3h158.6c4,0,7.3,3.3,7.3,7.3v143.1c0,5.1-4.2,9.3-9.3,9.3ZM20.7,32.5c-.7,0-1.3.6-1.3,1.3v145.1c0,.7.6,1.3,1.3,1.3h156.6c1.8,0,3.3-1.5,3.3-3.3V33.8c0-.7-.6-1.3-1.3-1.3H20.7Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-white",
    d: "M33.3,45.4c-1.7,0-3-1.3-3-3v-25.6c0-1.7,1.3-3,3-3s3,1.3,3,3v25.6c0,1.7-1.3,3-3,3Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-white",
    d: "M67.3,45.4c-1.7,0-3-1.3-3-3v-25.6c0-1.7,1.3-3,3-3s3,1.3,3,3v25.6c0,1.7-1.3,3-3,3Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-white",
    d: "M101.3,45.4c-1.7,0-3-1.3-3-3v-25.6c0-1.7,1.3-3,3-3s3,1.3,3,3v25.6c0,1.7-1.3,3-3,3Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-white",
    d: "M135.3,45.4c-1.7,0-3-1.3-3-3v-25.6c0-1.7,1.3-3,3-3s3,1.3,3,3v25.6c0,1.7-1.3,3-3,3Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-white",
    d: "M169.3,45.4c-1.7,0-3-1.3-3-3v-25.6c0-1.7,1.3-3,3-3s3,1.3,3,3v25.6c0,1.7-1.3,3-3,3Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-white",
    d: "M183.6,62.2H16.4c-1.7,0-3-1.3-3-3s1.3-3,3-3h167.2c1.7,0,3,1.3,3,3s-1.3,3-3,3Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-white",
    d: "M47.8,104.2h-16.9c-1.7,0-3-1.3-3-3v-16.9c0-1.7,1.3-3,3-3h16.9c1.7,0,3,1.3,3,3v16.9c0,1.7-1.3,3-3,3ZM33.9,98.2h10.9v-10.9h-10.9v10.9Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-white",
    d: "M88.7,104.2h-16.9c-1.7,0-3-1.3-3-3v-16.9c0-1.7,1.3-3,3-3h16.9c1.7,0,3,1.3,3,3v16.9c0,1.7-1.3,3-3,3ZM74.8,98.2h10.9v-10.9h-10.9v10.9Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-white",
    d: "M129.6,104.2h-16.9c-1.7,0-3-1.3-3-3v-16.9c0-1.7,1.3-3,3-3h16.9c1.7,0,3,1.3,3,3v16.9c0,1.7-1.3,3-3,3ZM115.8,98.2h10.9v-10.9h-10.9v10.9Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-white",
    d: "M170.5,104.2h-16.9c-1.7,0-3-1.3-3-3v-16.9c0-1.7,1.3-3,3-3h16.9c1.7,0,3,1.3,3,3v16.9c0,1.7-1.3,3-3,3ZM156.7,98.2h10.9v-10.9h-10.9v10.9Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-white",
    d: "M47.8,139.3h-16.9c-1.7,0-3-1.3-3-3v-16.9c0-1.7,1.3-3,3-3h16.9c1.7,0,3,1.3,3,3v16.9c0,1.7-1.3,3-3,3ZM33.9,133.3h10.9v-10.9h-10.9v10.9Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-white",
    d: "M88.7,139.3h-16.9c-1.7,0-3-1.3-3-3v-16.9c0-1.7,1.3-3,3-3h16.9c1.7,0,3,1.3,3,3v16.9c0,1.7-1.3,3-3,3ZM74.8,133.3h10.9v-10.9h-10.9v10.9Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-white",
    d: "M129.6,139.3h-16.9c-1.7,0-3-1.3-3-3v-16.9c0-1.7,1.3-3,3-3h16.9c1.7,0,3,1.3,3,3v16.9c0,1.7-1.3,3-3,3ZM115.8,133.3h10.9v-10.9h-10.9v10.9Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-white",
    d: "M170.5,139.3h-16.9c-1.7,0-3-1.3-3-3v-16.9c0-1.7,1.3-3,3-3h16.9c1.7,0,3,1.3,3,3v16.9c0,1.7-1.3,3-3,3ZM156.7,133.3h10.9v-10.9h-10.9v10.9Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-white",
    d: "M47.8,174.4h-16.9c-1.7,0-3-1.3-3-3v-16.9c0-1.7,1.3-3,3-3h16.9c1.7,0,3,1.3,3,3v16.9c0,1.7-1.3,3-3,3ZM33.9,168.4h10.9v-10.9h-10.9v10.9Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-white",
    d: "M88.7,174.4h-16.9c-1.7,0-3-1.3-3-3v-16.9c0-1.7,1.3-3,3-3h16.9c1.7,0,3,1.3,3,3v16.9c0,1.7-1.3,3-3,3ZM74.8,168.4h10.9v-10.9h-10.9v10.9Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalander);
export default __webpack_public_path__ + "static/media/calander.e5b78855fce2b6261fea841fa6abc199.svg";
export { ForwardRef as ReactComponent };